import * as React from "react";
import type { SVGProps } from "react";
const SvgBackpackWithCheckMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.93 11.88a1.007 1.007 0 1 0-2 .25q.058.434.07.87v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-7a7 7 0 0 1 9.62-6.49A1 1 0 0 0 15.93 6c.077-.217.07-.67.07-.67s-.003-.217 0-.33V4a3 3 0 0 0-3-3h-2a3 3 0 0 0-3 3v1a9 9 0 0 0-5 8v7a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-7a8 8 0 0 0-.07-1.12M10 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M7 12a1 1 0 0 0-1 1v4a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-2a1 1 0 0 0-2 0v2a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-4a1 1 0 0 0-1-1"
    />
    <path
      fill="currentColor"
      d="M10.204 12.09a1 1 0 0 1 .626.36L12 14.23l6.18-8.8a1 1 0 0 1 1.64 1.14l-7 10A1 1 0 0 1 12 17a1 1 0 0 1-.83-.45l-2-3a1 1 0 0 1 1.034-1.46"
    />
  </svg>
);
export default SvgBackpackWithCheckMark;
